import { useNow } from '@vueuse/core'
import { acceptHMRUpdate, defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

export const useRouteLoadingStore = defineStore('routeLoading', () => {
  const router = useRouter()
  const now = useNow({ interval: 1000 })

  const LOAD_REQUEST_TIMEOUT = 5000

  const loadingRequestId = ref(0)
  const loadingRequests = ref({})
  const routerNavigating = ref(false)
  
  router.beforeEach(() => {
    routerNavigating.value = true
  })
  router.afterEach(() => {
    routerNavigating.value = false
  })

  const hasLoadingRequest = computed(() => Object.values(loadingRequests.value).some(timestamp => now.value - timestamp < LOAD_REQUEST_TIMEOUT))
  const isRouteLoading = computed(() => routerNavigating.value || hasLoadingRequest.value)

  const addLoadingRequest = () => {
    const id = loadingRequestId.value++
    loadingRequests.value[id] = Date.now()
    return id
  }

  const removeLoadingRequest = (id) => {
    delete loadingRequests.value[id]
  }


  return {
    loadingRequestId,
    loadingRequests,
    routerNavigating,
    hasLoadingRequest,
    isRouteLoading,
    addLoadingRequest,
    removeLoadingRequest
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useRouteLoadingStore, import.meta.hot))
